import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import AppRouter from './AppRouter';
import {BrowserRouter} from 'react-router-dom';
import * as serviceWorker from './serviceWorker';
import * as Sentry from '@sentry/react';
import {GoogleOAuthProvider} from '@react-oauth/google';
import {ThemeProvider} from './context/ThemeProvider';
import ErrorFallback from './components/ErrorFallback';

Sentry.init({
  dsn: 'https://95da26e0f7fa59396df1a9a4bb713ce8@o1087437.ingest.us.sentry.io/4510192838770688',
  environment: process.env.REACT_APP_CURRENT_BRANCH || 'development',
  integrations: [Sentry.browserTracingIntegration()],

  // Performance Monitoring
  tracesSampleRate: 1,

  // Fetch aborts on unmount / superseded requests are expected, not product bugs
  ignoreErrors: ['AbortError', /signal is aborted/i, /The user aborted a request/i],

  // Don't send errors in development
  beforeSend(event, hint) {
    if (process.env.NODE_ENV === 'development') {
      console.log('Sentry event:', event);
      return null; // Don't send to Sentry in dev
    }
    const error = hint?.originalException;
    if (
      error?.name === 'AbortError' ||
      event?.exception?.values?.some(v => v.type === 'AbortError')
    ) {
      return null;
    }
    return event;
  },
});

ReactDOM.render(
  <ThemeProvider>
    <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
      <GoogleOAuthProvider clientId="110167923738-nsajf53a3svvskn3qlp2hapclg7p6924.apps.googleusercontent.com">
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
      </GoogleOAuthProvider>
    </Sentry.ErrorBoundary>
  </ThemeProvider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
